/* eslint-disable camelcase */

export type BankAccountDeprecated = {
  id: number
  company_id: number | null
  number: string
  notes: string
  created_at: Date | null
  updated_at: Date | null
  licensed: boolean
  license_ids: number[]
  opening_date: string | null
  internal_transfers_type: number
}
